export default {
  'npm_package_version': '1.1.8'
};
